import {
  createComponentMapperModel,
  withCompInfo,
} from '@wix/editor-elements-integrations';
import { logoPlaceholder, texts } from './constants';
import type { FreemiumBannerOdeditorMapperProps } from '../FreemiumBannerOdeditor.types';

export const props = withCompInfo<FreemiumBannerOdeditorMapperProps, any>()(
  ['direction', 'translate'],
  ({ direction, translate }) => {
    const mainText = translate(texts.NAMESPACE, texts.MAIN_TEXT_LIVE_KEY);
    const textBeforeLogo =
      mainText?.split(logoPlaceholder)[0] ?? texts.MAIN_TEXT_LIVE_DEFAULT;
    return {
      direction,
      textBeforeLogo,
      href: 'https://wixharmony.com',
      logoText: 'Wix',
    };
  },
);

export default createComponentMapperModel({ props });
